import { useMemo } from 'react';
import type { AssetAnalysisData, PieChartData } from '../types';

interface UseAssetAnalysisFormatReturn {
  formatAmount: (amount: number) => string;
  formatReturnRate: (rate: number) => string;
  getPieData: (allocation: AssetAnalysisData['assetAllocation']) => PieChartData[];
}

/**
 * 资产分析数据的格式化工具
 */
export function useAssetAnalysisFormat(): UseAssetAnalysisFormatReturn {
  // 格式化金额显示
  const formatAmount = useMemo(
    () => (amount: number) => {
      if (amount >= 10000) {
        return `¥${(amount / 10000).toFixed(1)}万`;
      }
      return `¥${amount.toLocaleString()}`;
    },
    []
  );

  // 格式化收益率显示
  const formatReturnRate = useMemo(
    () => (rate: number) => {
      const sign = rate >= 0 ? '+' : '';
      return `${sign}${rate.toFixed(2)}%`;
    },
    []
  );

  // 饼图数据转换
  const getPieData = useMemo(
    () =>
      (allocation: AssetAnalysisData['assetAllocation']): PieChartData[] => [
        {
          name: '权益类资产(股票)',
          value: allocation.equity,
          color: '#5959EB',
          fill: '#5959EB'
        },
        {
          name: '固收类资产(债券)',
          value: allocation.fixedIncome,
          color: '#EB2F96',
          fill: '#EB2F96'
        },
        {
          name: '货币类资产(现金)',
          value: allocation.cash,
          color: '#1677FF',
          fill: '#1677FF'
        },
        {
          name: '商品类资产',
          value: allocation.commodity,
          color: '#13C2C2',
          fill: '#13C2C2'
        }
      ],
    []
  );

  return {
    formatAmount,
    formatReturnRate,
    getPieData
  };
}
